import type { DatasetForm, DatasetFormDataJson } from "@/entities/dataset";

export const getDatasetFormData = (dataset?: DatasetForm) => {
  if (!dataset?.data) return undefined;

  const values = JSON.parse(dataset.data);

  if (!values) return undefined;

  return values as DatasetFormDataJson;
};
